import { useRef } from "react";

import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { Icon } from "../../../../components/base/Icon";
import LeftArrowIcon from "../../../../assets/images/buildings/LeftArrow.svg";
import RightArrowIcon from "../../../../assets/images/buildings/RightArrow.svg";

export const useStyles = makeStyles((theme) => ({
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 85,
    height: 85,
    borderRadius: "100%",
    background: COLORS.darks[0][6],
    marginLeft: 50,
  },
  type: {
    margin: "0 12px",
    minWidth: 260,
    textAlign: "left",
  },
  root: {
    marginBottom: theme.spacing(4),
  },
  carousel: {
    width: "100%",
    scrollSnapType: "x mandatory",
    whiteSpace: "nowrap",
    minHeight: 150,
  },
}));

export const CarouselContainer = ({ children, step, nextStep, previousStep, carouselType }) => {
  const classes = useStyles();
  const ref = useRef(null);

  return (
    <>
      <Grid container className={classes.root} justifyContent="center" alignItems="center">
        <Icon
          style={{ cursor: "pointer" }}
          src={LeftArrowIcon}
          onClick={() => {
            ref.current.scrollBy({
              left: -ref.current.clientWidth,
              behavior: "smooth",
            });
            previousStep();
          }}
        />

        <Box className={classes.icon}>
          <Icon src={carouselType[step].icon} style={{ width: 55 }} />
        </Box>
        <Typography variant="h3" className={classes.type}>
          {carouselType[step].name}
        </Typography>

        <Icon
          style={{ cursor: "pointer" }}
          src={RightArrowIcon}
          onClick={() => {
            ref.current.scrollBy({
              left: ref.current.clientWidth,
              behavior: "smooth",
            });
            nextStep();
          }}
        />
      </Grid>
      <Box className={classes.carousel} ref={ref}>
        {children}
      </Box>
    </>
  );
};
